var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect } from "react";
import { Header, HeaderWidget as S7HeaderWidget, useHeader, useHeaderContext, } from "@s7/header";
import { connect } from "react-redux";
import { injectIntl } from "@s7ui-kit/s7ui-kit";
import { SocialMessage } from "@s7/icons";
import { analytics } from "../../../../services/analytics/analyticsManager";
import { adapter } from "../api/header-adapter";
import { HeaderWidgetSkeleton } from "./HeaderWidgetSkeleton";
import { HeaderProfile } from "./HeaderProfile";
import { useMediaQuery, zIndex } from "@s7/styles";
var mapStateToProps = function (state) { return ({
    lang: state.App.lang,
}); };
export var HEADER_Z_INDEX = zIndex("popover") + 11;
var HeaderChat = function (props) {
    var device = useHeaderContext().device;
    return (React.createElement(Header.Icon, __assign({}, props, { leftSide: React.createElement(SocialMessage, { size: device === "DESKTOP" ? 20 : 24 }) })));
};
var HEADER_CODE = "default";
var HEADER_VARIANT = "default";
var HeaderWidget = React.memo(function (props) {
    var lang = props.lang, words = props.words, getMessage = props.getMessage;
    var isDesktop = useMediaQuery("md1.up", {
        ssr: false,
        fallback: true,
    })[0];
    var device = isDesktop ? "DESKTOP" : "MOBILE";
    var store = useHeader({
        adapter: adapter,
        components: {
            chat: HeaderChat,
            profile: HeaderProfile,
        },
        componentsProps: {
            chat: {
                onClick: function () { var _a; return (_a = window.chat) === null || _a === void 0 ? void 0 : _a.toggleOpenChat(); },
            },
        },
        defaultIdent: {
            lang: lang,
            code: HEADER_CODE,
            variant: HEADER_VARIANT,
            device: device,
        },
    });
    useEffect(function () {
        store.setDevice(device);
    }, [device]);
    useEffect(function () {
        store.updateProps("profile", {
            loginLabel: getMessage(words, "s7ui.kit.header.popup.login.come.in.title"),
        });
    }, [words, getMessage]);
    return (React.createElement(S7HeaderWidget, { key: device, analytics: analytics, renderSkeleton: HeaderWidgetSkeleton, store: store, containerProps: { zIndex: HEADER_Z_INDEX } }));
});
export default connect(mapStateToProps)(injectIntl(HeaderWidget));
